import React from 'react';
import './StatisticalSummary.css';

function StatisticalSummary({ stats }) {
  if (!stats) return null;

  const isSignificant = stats.p_value != null && stats.p_value < (stats.significance_threshold || 0.05);

  const formatPValue = (p) => {
    if (p == null) return '--';
    if (p < 0.001) return 'p < 0.001';
    return `p = ${p.toFixed(4)}`;
  };

  const formatCI = (ci) => {
    if (!ci || ci.length < 2) return '--';
    return `[${(ci[0] * 100).toFixed(1)}%, ${(ci[1] * 100).toFixed(1)}%]`;
  };

  const formatPercent = (val) => {
    if (val == null) return '--';
    return (val * 100).toFixed(2) + '%';
  };

  const formatNumber = (val) => {
    if (val == null) return '--';
    return typeof val === 'number' ? val.toFixed(4) : val;
  };

  return (
    <div className={`statistical-summary ${isSignificant ? 'significant' : ''}`}>
      <div className="stats-grid">
        <div className="stats-item">
          <span className="stats-label">Sample Size</span>
          <span className="stats-value">{(stats.sample_size ?? 0).toLocaleString()}</span>
        </div>
        <div className="stats-item">
          <span className="stats-label">Conversion Rate</span>
          <span className="stats-value">{formatPercent(stats.conversion_rate)}</span>
        </div>
        <div className="stats-item">
          <span className="stats-label">Z-Score</span>
          <span className="stats-value">{formatNumber(stats.z_score)}</span>
        </div>
        <div className="stats-item">
          <span className="stats-label">P-Value</span>
          <span className={`stats-value ${isSignificant ? 'stats-significant' : ''}`}>
            {formatPValue(stats.p_value)}
          </span>
        </div>
        <div className="stats-item">
          <span className="stats-label">Confidence Level</span>
          <span className="stats-value">
            {stats.confidence_level != null
              ? `${(stats.confidence_level * 100).toFixed(1)}%`
              : '--'}
          </span>
        </div>
        <div className="stats-item">
          <span className="stats-label">Confidence Interval</span>
          <span className="stats-value">{formatCI(stats.confidence_interval)}</span>
        </div>
        <div className="stats-item">
          <span className="stats-label">Lift</span>
          <span className={`stats-value ${stats.lift > 0 ? 'stats-positive' : stats.lift < 0 ? 'stats-negative' : ''}`}>
            {stats.lift != null ? `${stats.lift > 0 ? '+' : ''}${(stats.lift * 100).toFixed(2)}%` : '--'}
          </span>
        </div>
        <div className="stats-item">
          <span className="stats-label">Power</span>
          <span className="stats-value">
            {stats.power != null ? `${(stats.power * 100).toFixed(1)}%` : '--'}
          </span>
        </div>
      </div>
      {isSignificant && (
        <div className="stats-significance-badge">Statistically Significant</div>
      )}
    </div>
  );
}

export default StatisticalSummary;
